








import { Component, Vue, Prop } from "vue-property-decorator";
import { VNode } from "vue";
import CustomReportTransfer from "../../modules/custom/report-transfer.vue";
@Component({
  components: {
    CustomReportTransfer
  }
})
export default class DigReportDetailTranslateCmp extends Vue {
  @Prop()
  private message: any;
  private resultNode: any | undefined;
}
